import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { hasPermissionSelector } from './selector';

export const useHasPermission = permission => {
  const location = useLocation();
  const hasPermission = useSelector(hasPermissionSelector);
  if (typeof permission === 'object' && !permission.menu)
    permission.menu = location.pathname;
  return hasPermission(permission);
};
